"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Named DmsEnum to match the name in c# AutoAlert.AlertMiner.ServiceContract
exports.DmsEnum = {
    NA: 0,
    CDK: 1,
    RCI: 2,
    AutoMate: 5,
    DealerTrack: 9,
    PBS: 16,
    Serti: 23,
    Adf: 18,
    Dealerbuilt: 38,
    Autovance: 39,
    Tekion: 40,
    SevenHundredCredit: 41,
    SevenHundredPrescreen: 42,
    AutoFi: 43,
    RouteOne: 1000,
    VinSolutions: 44
};
